/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "protos.projects.v1";

export interface SingleBulkRepoChange {
  updateTags: boolean;
  tags: string[];
}

export interface BulkEditReposItem {
  repoId: number;
  change: SingleBulkRepoChange | undefined;
}

export interface BulkEditReposRequest {
  deploymentId: number;
  changes: BulkEditReposItem[];
}

export interface BulkEditReposResponse {
  /** once we make protos for Repository, this should be updated to return whole Repo objects */
  updatedRepoNames: string[];
}

function createBaseSingleBulkRepoChange(): SingleBulkRepoChange {
  return { updateTags: false, tags: [] };
}

export const SingleBulkRepoChange = {
  encode(message: SingleBulkRepoChange, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.updateTags === true) {
      writer.uint32(8).bool(message.updateTags);
    }
    for (const v of message.tags) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SingleBulkRepoChange {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSingleBulkRepoChange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.updateTags = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tags.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SingleBulkRepoChange {
    return {
      updateTags: isSet(object.updateTags) ? Boolean(object.updateTags) : false,
      tags: Array.isArray(object?.tags) ? object.tags.map((e: any) => String(e)) : [],
    };
  },

  toJSON(message: SingleBulkRepoChange): unknown {
    const obj: any = {};
    if (message.updateTags === true) {
      obj.updateTags = message.updateTags;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SingleBulkRepoChange>, I>>(base?: I): SingleBulkRepoChange {
    return SingleBulkRepoChange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SingleBulkRepoChange>, I>>(object: I): SingleBulkRepoChange {
    const message = createBaseSingleBulkRepoChange();
    message.updateTags = object.updateTags ?? false;
    message.tags = object.tags?.map((e) => e) || [];
    return message;
  },
};

function createBaseBulkEditReposItem(): BulkEditReposItem {
  return { repoId: 0, change: undefined };
}

export const BulkEditReposItem = {
  encode(message: BulkEditReposItem, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.repoId !== 0) {
      writer.uint32(8).int32(message.repoId);
    }
    if (message.change !== undefined) {
      SingleBulkRepoChange.encode(message.change, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BulkEditReposItem {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBulkEditReposItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.repoId = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.change = SingleBulkRepoChange.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BulkEditReposItem {
    return {
      repoId: isSet(object.repoId) ? Number(object.repoId) : 0,
      change: isSet(object.change) ? SingleBulkRepoChange.fromJSON(object.change) : undefined,
    };
  },

  toJSON(message: BulkEditReposItem): unknown {
    const obj: any = {};
    if (message.repoId !== 0) {
      obj.repoId = Math.round(message.repoId);
    }
    if (message.change !== undefined) {
      obj.change = SingleBulkRepoChange.toJSON(message.change);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BulkEditReposItem>, I>>(base?: I): BulkEditReposItem {
    return BulkEditReposItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BulkEditReposItem>, I>>(object: I): BulkEditReposItem {
    const message = createBaseBulkEditReposItem();
    message.repoId = object.repoId ?? 0;
    message.change = (object.change !== undefined && object.change !== null)
      ? SingleBulkRepoChange.fromPartial(object.change)
      : undefined;
    return message;
  },
};

function createBaseBulkEditReposRequest(): BulkEditReposRequest {
  return { deploymentId: 0, changes: [] };
}

export const BulkEditReposRequest = {
  encode(message: BulkEditReposRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).int64(message.deploymentId);
    }
    for (const v of message.changes) {
      BulkEditReposItem.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BulkEditReposRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBulkEditReposRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.changes.push(BulkEditReposItem.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BulkEditReposRequest {
    return {
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      changes: Array.isArray(object?.changes) ? object.changes.map((e: any) => BulkEditReposItem.fromJSON(e)) : [],
    };
  },

  toJSON(message: BulkEditReposRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.changes?.length) {
      obj.changes = message.changes.map((e) => BulkEditReposItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BulkEditReposRequest>, I>>(base?: I): BulkEditReposRequest {
    return BulkEditReposRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BulkEditReposRequest>, I>>(object: I): BulkEditReposRequest {
    const message = createBaseBulkEditReposRequest();
    message.deploymentId = object.deploymentId ?? 0;
    message.changes = object.changes?.map((e) => BulkEditReposItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBulkEditReposResponse(): BulkEditReposResponse {
  return { updatedRepoNames: [] };
}

export const BulkEditReposResponse = {
  encode(message: BulkEditReposResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.updatedRepoNames) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BulkEditReposResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBulkEditReposResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.updatedRepoNames.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BulkEditReposResponse {
    return {
      updatedRepoNames: Array.isArray(object?.updatedRepoNames)
        ? object.updatedRepoNames.map((e: any) => String(e))
        : [],
    };
  },

  toJSON(message: BulkEditReposResponse): unknown {
    const obj: any = {};
    if (message.updatedRepoNames?.length) {
      obj.updatedRepoNames = message.updatedRepoNames;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BulkEditReposResponse>, I>>(base?: I): BulkEditReposResponse {
    return BulkEditReposResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BulkEditReposResponse>, I>>(object: I): BulkEditReposResponse {
    const message = createBaseBulkEditReposResponse();
    message.updatedRepoNames = object.updatedRepoNames?.map((e) => e) || [];
    return message;
  },
};

export interface SupportService {
  bulkEditRepos(request: BulkEditReposRequest): Promise<BulkEditReposResponse>;
}

export const SupportServiceServiceName = "protos.projects.v1.SupportService";
export class SupportServiceClientImpl implements SupportService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || SupportServiceServiceName;
    this.rpc = rpc;
    this.bulkEditRepos = this.bulkEditRepos.bind(this);
  }
  bulkEditRepos(request: BulkEditReposRequest): Promise<BulkEditReposResponse> {
    const data = BulkEditReposRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "BulkEditRepos", data);
    return promise.then((data) => BulkEditReposResponse.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

declare const self: any | undefined;
declare const window: any | undefined;
declare const global: any | undefined;
const tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new tsProtoGlobalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
